import * as React from "react"
import {Skeleton} from "@mui/material";

import PriceTopMarketChangesTabs from "./Tabs";
import { usePriceDiscountTopMarketChanges } from "./@hooks";
import { DISPLAY_TABS } from "./@constants";
import PriceTopMarketChangesPriceTable from "./PriceChangesTable";
import PriceTopMarketChangesStockTable from "./StockChangesTable";

export default function PriceDiscountTopMarketChanges() {
	const { 
        isLoadingPrice, isLoadingStock, dataPrice, dataStock, displayTable, handleChangeTabs,
        countriesPrice, countriesStock, selectedCountryPrice, selectedCountryStock, 
        handleSelectedCountryPrice, handleSelectedCountryStock
    } = usePriceDiscountTopMarketChanges()

	if (isLoadingPrice && isLoadingStock)return <Skeleton variant="rectangular" height={500} />
    if(!dataPrice?.length && !dataStock?.length) return <></>
    
    return <>
        <PriceTopMarketChangesTabs
            value={displayTable}
            onChange={handleChangeTabs}
        />
        {displayTable === DISPLAY_TABS.PRICE_CHANGES && <PriceTopMarketChangesPriceTable 
            data={dataPrice} 
            isLoading={isLoadingPrice}
            selectedCountry={selectedCountryPrice}
            countries={countriesPrice}
            handleSelectedCountry={handleSelectedCountryPrice}
        />}

        {displayTable === DISPLAY_TABS.STOCK_CHANGES && <PriceTopMarketChangesStockTable 
            data={dataStock} 
            isLoading={isLoadingStock} 
            selectedCountry={selectedCountryStock}
            countries={countriesStock}
            handleSelectedCountry={handleSelectedCountryStock}
        />}
    </>
}